import { useState } from "react"
import { useParams } from "react-router"
import { Box, IconButton, Stack, Typography } from "@mui/material"
import { PageBreadcrumbContainer } from "lib/page-breadcrumb-container"
import LoadingScreen from "minimals-template/components/LoadingScreen"
import Iconify from "minimals-template/components/Iconify"
import { IS_LOADING } from "lib/graphql/return-is-loading-on-each-request"
import { withInitialValue } from "lib/graphql/with-initial-value"
import { ruleSet } from "routes/rule-sets/controller/rule-set"
import { RuleSetEditor } from "./rule-set-editor"
import { useDemand } from "lib/authorization/use-demand"
import { If } from "lib/@components/switch"

const parentCrumbs = [
    { label: "Optimiser", to: "/app/optimiser" },
    { label: "Rule Sets", to: "/app/optimiser?optimiserTab=rule-sets" },
]

export function RuleSetView() {
    const { id } = useParams()
    const rs = ruleSet.useResultsOnce({ id }, withInitialValue(IS_LOADING))
    const canManageOptimiser = useDemand("manageScenarios")
    const [menuAnchor, setMenuAnchor] = useState(null)

    if (rs === IS_LOADING) return <LoadingScreen description="Loading Rule Set" />

    if (!rs) {
        return (
            <PageBreadcrumbContainer title="Rule Set Not Found" parentCrumbs={parentCrumbs} sx={{ height: 1 }}>
                <Stack alignItems="center" justifyContent="center" sx={{ flex: 1, p: 3 }}>
                    <Typography variant="h6" color="text.secondary">
                        This rule set could not be found.
                    </Typography>
                </Stack>
            </PageBreadcrumbContainer>
        )
    }

    return (
        <PageBreadcrumbContainer
            title={rs.name}
            heading={
                <Stack direction="row" spacing={1} sx={{ alignItems: "center", display: "inline-flex" }}>
                    <Box>{rs.name}</Box>
                    <If value={canManageOptimiser}>
                        <IconButton aria-label="More options" data-cy="rule-set-menu" size="small" onClick={openMenu}>
                            <Iconify icon="eva:more-vertical-fill" />
                        </IconButton>
                    </If>
                </Stack>
            }
            description={rs.description}
            parentCrumbs={parentCrumbs}
            sx={{ height: 1 }}
        >
            <RuleSetEditor
                ruleSet={rs}
                id={id}
                menuAnchor={menuAnchor}
                setMenuAnchor={setMenuAnchor}
                readOnly={!canManageOptimiser}
            />
        </PageBreadcrumbContainer>
    )

    function openMenu(e) {
        setMenuAnchor(e.currentTarget)
    }
}
